import React from 'react';
import { PlaybackPanelWrapper, PlaybackPanel } from './style';
import { CalendarButton, ControlButtons, PlaybackButton, Slider } from './components';
import { isMobileOnly } from 'react-device-detect';

export const PlaybackControl = () => (
  <PlaybackPanelWrapper role='presentation'>
    <PlaybackPanel isMobile={isMobileOnly}>
      <PlaybackButton />
      <div
        role='presentation'
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          padding: '0 8px',
        }}>
        <Slider />
        <ControlButtons />
      </div>
      <CalendarButton />
    </PlaybackPanel>
  </PlaybackPanelWrapper>
);
